'use strict';

const $ = window.jQuery;

export default function () {
    if ($('.single-fiche-adherent').length <= 0) {
        return;
    }

    $('.member-tabs__nav button').on('click', function () {
        $('.member-tabs__nav button').removeClass('is-active');
        $(this).addClass('is-active');

        $('.member-tabs__content').slideUp();
        $(`#memberTab${$(this).data('tab')}`).slideDown();
    });
};
